<script setup lang="ts">
const methods = [
    { src: '/images/payment/visa_200x120.png', alt: 'Visa' },
    { src: '/images/payment/mastercard_200x120.png', alt: 'Mastercard' },
    { src: '/images/payment/paypal_200x120.png', alt: 'Paypal' },
    { src: '/images/payment/klarna_200x120.png', alt: 'Klarna' },
    { src: '/images/shipping/dhl_200x120.png', alt: 'DHL' },
]
</script>

<template>
    <div class="flex flex-wrap gap-x-10 gap-y-5 py-4 lg:py-0">
        <div
            v-for="method in methods"
            :key="method.src"
            class="shrink-0"
        >
            <img
                :src="method.src"
                :alt="method.alt"
                class="object-contain border border-border bg-base-100 w-19"
                loading="lazy"
            >
        </div>
    </div>
</template>
